import React from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Mission from './components/Mission';
import WhyUs from './components/WhyUs';
import FAQ from './components/FAQ';
import Destinations from './components/Destinations';
import Testimonials from './components/Testimonials';
import CTAFinal from './components/CTAFinal';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <>
      <Nav />
      <header role="banner">
        <Hero />
      </header>
      <main>
        <section id="quienes-somos" aria-labelledby="quienes-somos-title">
          <About />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="servicios" aria-labelledby="servicios-title">
          <Services />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="mision" aria-labelledby="mision-title">
          <Mission />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="nuestro-compromiso" aria-labelledby="why-title">
          <WhyUs />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="lugares" aria-labelledby="lugares-title">
          <Destinations />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="testimonios" aria-labelledby="testimonios-title">
          <Testimonials />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="faq" aria-labelledby="faq-title">
          <FAQ />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="cta-final" aria-labelledby="cta-final-title">
          <CTAFinal />
        </section>
        <div className="section-separator" aria-hidden="true" />
        <section id="contacto" aria-labelledby="contacto-title">
          <Contact />
        </section>
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ScrollToTop />
    </>
  );
}

export default App;
